var map = {
	"./activity/less.svg": "5d2e",
	"./activity/more.svg": "b47b",
	"./activity/same.svg": "a1d5",
	"./pain/less.svg": "9b2f",
	"./pain/more.svg": "8372",
	"./pain/same.svg": "2402",
	"./sleep/better.svg": "b295",
	"./sleep/same.svg": "f75a",
	"./sleep/worse.svg": "3935"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "05e0";